import React from 'react';
import './adv.scss';
import Mood from '@material-ui/icons/Mood';

const context = {
  ru: {
    title: 'Увлечения',
    str1: 'Программирование ',
    str2: 'Видеосъемка, видеомонтаж, Спутниковое ТВ и IPTV, Автомобиль',
  },
  en: {
    title: 'Hobbies',
    str1: 'Programming',
    str2: 'Video Editing, Satelite TV & IPTV , Car ',
  },
};

const Edu = ({ lang }) => {
  const { title, str1, str2 } = context[lang];
  return (
    <div className='Adv'>
      <hr />
      <h4>{title}</h4>
      <hr />
      <p>
        {str1}
        {'  '}
        <Mood />
        {'  '}
        {str2}
      </p>
    </div>
  );
};

export default Edu;
